import React from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import Slide1 from "../images/Slider1.jpg";
import SlideMobile1 from "../images/SliderMobile1.jpg";
import { TypeAnimation } from "react-type-animation";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";

const Carousel = () => {
  // Common settings for both sliders
  const sliderSettings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    cssEase: "linear",
    autoplaySpeed: 5000,
    pauseOnHover: false,
    pauseOnFocus: false,
    pauseOnDotsHover: false,
    arrows: false,
    dotsClass: "carousel-dots",
  };

  // Desktop-specific settings
  const desktopSettings = {
    ...sliderSettings,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  return (
    <section className="hero-carousel">
      {/* Desktop Carousel */}
      <div className="desktop-carousel">
        <Slider {...desktopSettings}>
          <SlideContent
            image={Slide1}
            isMobile={false}
            titleSequence={[
              "Top Notch Professional Installation Guaranteed",
              2000,
              "Reliable Renewable Energy Solutions",
              2000,
              "24/7 Uninterrupted Power Supply",
              2000,
              "Premium Solar & Inverter Systems",
              2000,
            ]}
            subtitle="Leading Nigerian provider of reliable inverter systems, battery backup solutions, and high-performance solar installations"
          />
        </Slider>
      </div>

      {/* Mobile Carousel */}
      <div className="mobile-carousel">
        <Slider {...sliderSettings}>
          <SlideContent
            image={SlideMobile1}
            isMobile={true}
            titleSequence={[
              "Professional Installation",
              1800,
              "Reliable Energy Solutions",
              1800,
              "Uninterrupted Power",
              1800,
              "Premium Solar Systems",
              1800,
            ]}
            subtitle="Quality inverter, battery backup & solar installations for homes & businesses"
          />
        </Slider>
      </div>
    </section>
  );
};

// Slide Content Component (Reusable for both desktop and mobile)
const SlideContent = ({ image, isMobile, titleSequence, subtitle }) => {
  return (
    <div className="slide-item">
      <div className="slide-background">
        <img
          src={image}
          alt={
            isMobile
              ? "Mobile solar installation"
              : "Professional solar installation"
          }
          loading={isMobile ? "eager" : "lazy"}
        />
      </div>
      <div className="slide-overlay"></div>
      <div className="slide-content container">
        <div
          className={`carousel-text ${
            isMobile ? "mobile-text" : "desktop-text"
          }`}
        >
          {isMobile ? (
            <>
              <TypeAnimation
                className="mobile-type-animation"
                sequence={titleSequence}
                wrapper="h1"
                repeat={Infinity}
                speed={40}
                deletionSpeed={60}
                style={{
                  fontSize: "2rem",
                  lineHeight: "1.2",
                  marginBottom: "15px",
                  minHeight: "70px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  textAlign: "center",
                }}
              />
              <p className="carousel-subtitle mobile-subtitle">{subtitle}</p>
              <Link to="/packages" className="btn-carousel mobile-btn">
                SHOP NOW
              </Link>
            </>
          ) : (
            <>
              <TypeAnimation
                className="desktop-type-animation"
                sequence={titleSequence}
                wrapper="h1"
                repeat={Infinity}
                speed={30}
                deletionSpeed={50}
                style={{
                  fontSize: "3.5rem",
                  lineHeight: "1.1",
                  marginBottom: "20px",
                  minHeight: "130px",
                  display: "flex",
                  alignItems: "center",
                }}
              />
              <p className="carousel-subtitle desktop-subtitle">{subtitle}</p>
              <Link to="/packages" className="btn-carousel desktop-btn">
                SHOP NOW
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

// Custom Arrow Components
const NextArrow = (props) => {
  const { onClick } = props;
  return (
    <div
      className="custom-arrow next-arrow"
      onClick={onClick}
      aria-label="Next slide"
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
      >
        <path d="M9 18l6-6-6-6" />
      </svg>
    </div>
  );
};

const PrevArrow = (props) => {
  const { onClick } = props;
  return (
    <div
      className="custom-arrow prev-arrow"
      onClick={onClick}
      aria-label="Previous slide"
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
      >
        <path d="M15 18l-6-6 6-6" />
      </svg>
    </div>
  );
};

export default Carousel;
